import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

interface KanbanFilterState {
  startDateFilter: Date | null
  endDateFilter: Date | null
}

const initialState: KanbanFilterState = {
  startDateFilter: null,
  endDateFilter: null,
}

const kanbanFilterSlice = createSlice({
  name: 'kanbanFilter',
  initialState,
  reducers: {
    setStartDateFilter(state, action: PayloadAction<{ value: Date | null }>) {
      state.startDateFilter = action.payload.value
    },
    setEndDateFilter(state, action: PayloadAction<{ value: Date | null }>) {
      state.endDateFilter = action.payload.value
    },
  },
})

export const { setStartDateFilter, setEndDateFilter } =
  kanbanFilterSlice.actions

const KanbanFilterReducer = kanbanFilterSlice.reducer

export default KanbanFilterReducer
